import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/home'

Vue.use(VueRouter)
const routes=[
    {
        path:"/resume", component:Home
    },
    {
        path:"*",redirect: '/resume'
    }
]

const router = new VueRouter({
    mode:"history",
    routes
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js